import React from 'react'
import { prop } from 'ramda'

import * as API from '~/constants/api'
import MultiSelectSearchField from '~/components/Fields/MultiSelectSearchField'

const getOptionLabel = item => {
  if (item) {
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)
    return `${firstName} ${lastName}`
  }

  return ''
}

const getOptionValue = item => {
  if (item) {
    const id = prop('guid', item)
    const firstName = prop('firstName', item)
    const lastName = prop('lastName', item)

    return { id, firstName, lastName }
  }

  return null
}

function PutawayUserField (props) {
  return (
    <MultiSelectSearchField
      api={API.USER_LIST}
      data-cy="assigned"
      name="assigned"
      label="Assigned to"
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      {...props}
    />
  )
}

export default PutawayUserField
